import * as React from "react";
import isNumber from "lodash/isNumber";
import useReportingByAICustomization from "security-app/components/Investigations/AIReport/hooks/useInvestigationReportingByAICustomization";
import { Button } from "components/bootstrap";
import { Icon, HoverForHelp } from "components/common";
import AIReportModal from "security-app/components/Investigations/AIReport/AIReportModal";
import useDisclosure from "util/hooks/useDisclosure";
const AIReportButton = ({
  investigation,
  small = false,
  logsCount,
  eventsCount
}) => {
  const [showAIReportModal, { open: openAIReportModal, close: closeAIReportModal }] = useDisclosure(false);
  const { enabled: enabledForBrand } = useReportingByAICustomization();
  const hasNoEvidence = isNumber(logsCount) && isNumber(eventsCount) && logsCount + eventsCount === 0;
  if (!enabledForBrand) return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Button,
    {
      disabled: hasNoEvidence,
      bsStyle: "primary",
      onClick: openAIReportModal,
      title: "Generate AI Report",
      bsSize: small ? "sm" : void 0
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "note_add", type: "regular", size: small ? "sm" : void 0 }),
    " ",
    !small && "AI Report",
    hasNoEvidence && /* @__PURE__ */ React.createElement(HoverForHelp, { title: "Add evidence" }, "Add a log or event to this investigation to generate an AI report.")
  ), showAIReportModal && /* @__PURE__ */ React.createElement(AIReportModal, { onCancel: closeAIReportModal, investigation }));
};
export default AIReportButton;
